export const GET_EMPLOYEE = 'providers/workforce/EmployeeDetails/GET_EMPLOYEE';
export const EDIT_EMPLOYEE = 'providers/workforce/EmployeeDetails/EDIT_EMPLOYEE';
export const UPDATE_PASSPORT = 'providers/workforce/EmployeeDetails/UPDATE_PASSPORT';
